import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';
import { environment } from 'src/environments/environment';
import { Chapter } from 'src/app/models/chapter.models';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class MetadataService {
  maintenanceMode = false;
  public brandLogo = new BehaviorSubject<string>('');

  constructor(
    private httpClient: HttpClient,
    private cookieService: CookieService,
    public router: Router,
    private translate: TranslateService
  ) { }

  getDummyChapters() {
    const chapters: Chapter[] = [
      {
        id: '1',
        title: 'Titulo del capitulo',
        completedThemes: 0,
        totalThemes: 3,
        enabled: true,
        progress: 0,
        bgGradient: 'linear-gradient(140deg, #00CAA8 0%, #078CC7 100%)',
        bgImage: '',
      },
      {
        id: '2',
        title: 'Titulo del capitulo',
        completedThemes: 0,
        totalThemes: 3,
        enabled: false,
        progress: 0,
        bgGradient: 'linear-gradient(140deg, #00CAA8 0%, #078CC7 100%)',
        bgImage: '',
      },
      {
        id: '3',
        title: 'Titulo del capitulo',
        completedThemes: 0,
        totalThemes: 3,
        enabled: false,
        progress: 0,
        bgGradient: 'linear-gradient(136deg, #F5C17D 0%, #FF3131 100%)',
        bgImage: '',
      },
      {
        id: '4',
        title: 'Titulo del capitulo',
        completedThemes: 0,
        totalThemes: 3,
        enabled: false,
        progress: 0,
        bgGradient: 'linear-gradient(136deg, #F5C17D 0%, #FF3131 100%)',
        bgImage: '',
      },
      {
        id: '5',
        title: 'Titulo del capitulo',
        completedThemes: 0,
        totalThemes: 3,
        enabled: false,
        progress: 0,
        bgGradient: '#000180',
        bgImage: '',
      },
      {
        id: '6',
        title: 'Titulo del capitulo',
        completedThemes: 0,
        totalThemes: 3,
        enabled: false,
        progress: 0,
        bgGradient: '#000180',
        bgImage: '',
      },
      {
        id: '7',
        title: 'Titulo del capitulo',
        completedThemes: 0,
        totalThemes: 3,
        enabled: false,
        progress: 0,
        bgGradient: '#000180',
        bgImage: '',
      },
      {
        id: '8',
        title: 'Titulo del capitulo',
        completedThemes: 0,
        totalThemes: 3,
        enabled: false,
        progress: 0,
        bgGradient: '#000180',
        bgImage: '',
      },
      {
        id: '9',
        title: 'Titulo del capitulo',
        completedThemes: 0,
        totalThemes: 3,
        enabled: false,
        progress: 0,
        bgGradient: '#000180',
        bgImage: '',
      },
      {
        id: '10',
        title: 'Titulo del capitulo',
        completedThemes: 0,
        totalThemes: 3,
        enabled: false,
        progress: 0,
        bgGradient: '#000180',
        bgImage: '',
      },
      {
        id: '11',
        title: 'Titulo del capitulo',
        completedThemes: 0,
        totalThemes: 3,
        enabled: false,
        progress: 0,
        bgGradient: '#000180',
        bgImage: '',
      },
      {
        id: '12',
        title: 'Titulo del capitulo',
        completedThemes: 0,
        totalThemes: 3,
        enabled: false,
        progress: 0,
        bgGradient: '#000180',
        bgImage: '',
      },
    ];
    return chapters;
  }

  getChartLabelsDict() {
    const labelsDict: any = {
      Téc: 'Técnico',
      Inv: 'Investigador',
      Emp: 'Emprendedor',
      Soc: 'Social',
      Ana: 'Analista',
      Art: 'Artístico',
      Pe: 'Perfeccionista',
      Al: 'Altruista',
      Ac: 'Activo',
      Af: 'Afectivo',
      Ra: 'Racional',
      Es: 'Escéptico',
      En: 'Entusiasta',
      Li: 'Liderazgo',
      Me: 'Mediador',
    };

    return labelsDict;
  }

  getChartLabels(category: string): string[] {
    let rawLabels: string[] = [];
    if (category === 'vocational_interests') {
      return ['Téc', 'Inv', 'Emp', 'Soc', 'Ana', 'Art'];
    } else if (category === 'professional_fields') {
      rawLabels = [
        'technical-manual',
        'scientific-investigative',
        'artistic-creative',
        'social-caregiving',
        'entrepreneurial-persuasive',
        'administrative-management',
        'digital-virtual-streamer',
      ];
    } else if (category == 'personalities') {
      return [
        'Pe', 'Al', 'Ac', 'Af', 'Ra', 'Es', 'En', 'Li', 'Me',
      ];
    } else if (category == 'multiple_intelligences') {
      rawLabels = [
        'linguistic',
        'mathematical-logic',
        'spatial',
        'kinesthetic-body',
        'musical',
        'intrapersonal',
        'interpersonal',
        'naturalistic',
      ];
    } else if (category == 'intelligences') {
      rawLabels = [
        'self-awareness',
        'empathy',
        'self-confidence',
        'motivation',
        'self-control',
        'social-competence',
      ];
    } else if (category == 'learning_styles') {
      rawLabels = ['active', 'reflective', 'theoretical', 'pragmatic'];
    } else if (category == 'avks') {
      rawLabels = ['auditory', 'visual', 'kinesthetic'];
    } else if (category == 'competencies') {
      rawLabels = [
        'adaptability',
        'communication-skills',
        'it-apps-training-level',
        'information-search',
        'digital-competence',
        'ict-usage-level',
        'project-management-and-problem-solving',
        'self-criticism',
        'self-learning',
        'social-skills',
        'time-management',
      ];
    } else if (category == 'psychometrics_personality') {
      rawLabels = [
        'openness-to-experience',
        'conscientiousness',
        'extraversion',
        'agreeableness',
        'neuroticism',
      ];
    } else if (category == 'psychometrics_avk') {
      rawLabels = [
        'visual_style',
        'auditory_style',
        'kinesthetic_style',
      ];
    } else if (category == 'psychometrics_emotional_regulation') {
      rawLabels = [
        'emotional_acceptance',
        'goal_persistence',
        'impulse_control',
        'emotional_awareness',
        'emotional_clarity',
        'emotional_regulation_strategies',
      ];
    } else if (category == 'psychometrics_vocational_interests_self_efficacy') {
      rawLabels = [
        'realistic',
        'investigative',
        'artistic',
        'social',
        'enterprising',
        'conventional',
      ];
    } else if (category == 'psychometrics_career_anchors') {
      rawLabels = [
        'autonomy_independence',
        'entrepreneurial_creativity',
        'service_dedication',
        'pure_challenge',
        'lifestyle',
        'general_management',
        'security_stability',
        'technical_functional'
      ];
    }

    return rawLabels.map(label => this.translate.instant('chartLabels.' + label));
  }

  getChartColors(category: any) {
    let colors: any;
    if (category == 'vocational_interests') {
      colors = [
        '#C9A8E6',
        '#A8E6DB',
        '#A8C8E6',
        '#E6BEA8',
        '#E6D3A8',
        '#E6A8A8',
        '#E6A8E6',
      ];
    } else if (category == 'professional_fields') {
      colors = [
        '#C9A8E6',
        '#A8E6DB',
        '#A8C8E6',
        '#E6BEA8',
        '#E6D3A8',
        '#E6A8A8',
        '#E6A8E6',
      ];
    } else if (category == 'personalities') {
      colors = {
        backgroundColor: '#00CAA866',
        borderColor: '#00CAA8',
        pointBackgroundColor: '#00CAA866',
        pointBorderColor: '#00CAA8',
        pointHoverBackgroundColor: '#fff',
        pointHoverBorderColor: '#300CAA8',
      };
    } else if (category == 'multiple_intelligences') {
      colors = [
        '#E5D2F6',
        '#A6ECE1',
        '#B1DAFF',
        '#FFDDCA',
        '#FFECC2',
        '#FDC1C1',
        '#E9B5E9',
        '#C2D5BD',
      ]
    } else if (category == 'intelligences') {
      colors = {
        background: [],
        borders: [],
      };
      colors.background = [
        '#F3B9D166',
        '#A6ECE166',
        '#B1DAFF66',
        '#FFDDCA66',
        '#FFECC266',
        '#FDC1C166',
      ];
      colors.borders = [
        '#F3B9D166',
        '#A6ECE166',
        '#B1DAFF66',
        '#FFDDCA66',
        '#FFECC266',
        '#FDC1C166',
      ];
    } if (category === 'learning_styles') {
      colors = ['#A6ECE1', '#F3B9D1', '#FFDDCA', '#A6C5FF'];
    } else if (category === 'avks') {
      colors = ['#FCDAA8', '#FFEBB4', '#C5DCFE'];
    } else if (category === 'competencies') {
      colors = ['#C5DCFE'];
    } else if (category === 'psychometrics_personality') {
      colors = ['#BB109D', '#CF005D', '#DC4F43', '#F7924F', '#FFCC73'];
    } else if (category === 'psychometrics_avk') {
      colors = ['#BB109D', '#CF005D', '#DC4F43'];
    } else if (category === 'psychometrics_emotional_regulation') {
      colors = ['#BB109D', '#CF005D', '#DC4F43', '#F7924F', '#FFCC73', '#E3E975'];
    } else if (category === 'psychometrics_vocational_interests_self_efficacy') {
      colors = ['#CF005D', '#00CADC'];
    } else if (category === 'psychometrics_career_anchors') {
      colors = ['#00CADC', '#49C3FB', '#65A6FA', '#7E80E7', '#9B57CC', '#BB109D', '#CF005D', '#DC4F43'];
    }
    return colors;
  }

  getSettings(): Observable<any> {
    const url = environment.apiUrl + '/system-settings/1/';
    return this.httpClient.get(url).pipe(
      catchError((error) => {
        return throwError(() => error);
      })
    );
  }

  canActivate() {
    let canActivate = true;

    this.getSettings().subscribe({
      next: (data: any) => {
        this.maintenanceMode = data.is_in_maintenance;
        if (data.logo) {
          // localStorage.setItem('brandlogo', data.logo)
        }

        if (this.maintenanceMode) {
          canActivate = false;
          this.router.navigate(['/maintenance-mode']);
        }
      },
      error: (e) => {
        console.debug(e);
      },
    });

    return canActivate;
  }
}
